export default {
  mycnc: 'MyCast&Crew',
  hoursplus: 'Hours +',
  startplus: 'Start +',
};
